import { z } from 'zod';

/**
 * The save document: one JSON blob holding all progress (the same scheme as lawnmower's).
 * Changing its shape means bumping the version and adding a step in ./migrate.ts.
 */
export const SAVE_VERSION = 1;

const Level = z.number().int().min(0).max(5);

export const SaveSchema = z.object({
  version: z.literal(SAVE_VERSION),
  /** Rare materials: kept through rewinds, spent on upgrades in the lab. */
  materials: z.number().int().min(0).default(0),
  // `prefault` (not `default`): a missing section is filled in by parsing `{}`, which applies the
  // field defaults, so one absent key never makes the whole save unreadable.
  upgrades: z
    .object({
      armor: Level.default(0),
      reactor: Level.default(0),
      thrusters: Level.default(0),
      shielding: Level.default(0),
      arsenal: Level.default(0),
    })
    .prefault({}),
  /** Story beats reached at least once, see ../progress.ts. */
  seen: z.array(z.string()).default([]),
  stats: z
    .object({
      runs: z.number().int().min(0).default(0),
      rewinds: z.number().int().min(0).default(0),
      bossesBeaten: z.number().int().min(0).default(0),
    })
    .prefault({}),
});

export type Save = z.infer<typeof SaveSchema>;

export function defaultSave(): Save {
  return {
    version: SAVE_VERSION,
    materials: 0,
    upgrades: { armor: 0, reactor: 0, thrusters: 0, shielding: 0, arsenal: 0 },
    seen: [],
    stats: { runs: 0, rewinds: 0, bossesBeaten: 0 },
  };
}
